import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { UniversityService } from '../../services/university.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { DateInputComponent } from "../../components/date-input/date-input.component";
import { RadioInputComponent } from "../../components/radio-input/radio-input.component";
import { CheckboxComponent } from "../../components/checkbox/checkbox.component";
import { ImageUploderComponent } from "../../components/image-uploder/image-uploder.component";
import { AssessmentService } from '../../services/assessment.service';
import { FormSectionComponent } from '../../components/form-section/form-section.component';


@Component({
  selector: 'app-assessment-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, RouterLink],
  templateUrl: './assessment-page.component.html',
  styleUrl: './assessment-page.component.css'
})
export class AssessmentPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Assessment';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];

  assessment_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', width: 90 },
    // { valueGetter: (params: any) => `${params.data.evaluation_start_date} - ${params.data.evaluation_end_date}`, headerName: 'Date', minWidth: 160, flex: 1 },
    { headerName: 'Subject (Code)', filter: true, flex: 2, valueGetter: (p: any) => [p.data?.Subject.name, `(${p.data?.Subject.code})`].filter(Boolean).join(` `) },
    { field: 'Exam.code', headerName: 'Exam Code', minWidth: 130, flex: 1 },
    { field: 'Exam.name', headerName: 'Exam Name', minWidth: 150, flex: 1 },
    { field: 'AcademicYear.name', headerName: 'Academic Year', minWidth: 140, flex: 1 },
    { field: 'evaluation_start_date', headerName: 'Evaluation Start Date', minWidth: 180, flex: 1 },
    { field: 'evaluation_end_date', headerName: 'Evaluation End Date', minWidth: 180, flex: 1 },
    { field: 'qp_pattern', headerName: 'Question Paper Pattern', minWidth: 220, flex: 1, cellRenderer: (params: any) => this.showFileLink(params, 'qp_pattern.csv') },
    { field: 'qp_file', headerName: 'Question Paper File', minWidth: 180, flex: 1, cellRenderer: (params: any) => this.showFileLink(params, 'qp_file.pdf') },
    { field: 'soe_upload', headerName: 'SOE Upload', minWidth: 150, flex: 1, cellRenderer: (params: any) => this.showFileLink(params, 'soe_upload.pdf') },
    { field: 'model_answer_sheet', headerName: 'Model Answer Sheet', minWidth: 180, flex: 1, cellRenderer: (params: any) => this.showFileLink(params, 'model_answer_sheet.pdf') },
    { headerName: "Actions", sortable: false, pinned: 'right', editable: false, width: 210, minWidth: 210, maxWidth: 210, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) } }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'City Name', type: 'text', return_as: 'city_id', sample_value: 'Mumbai Suburban' },
    { column_name: 'University Name', type: 'text', return_as: 'name', sample_value: 'Mumbai University' },
    { column_name: 'Address', type: 'text', return_as: 'address', sample_value: 'Vidya Nagari, Kalina, Santacruz East, Mumbai, Maharashtra 400098', min_length: 10, max_length: 250 },
    { column_name: 'Email id', type: 'text', return_as: 'email', sample_value: 'mumbai.university@gmail.com', strict_validation: 'email' },
    { column_name: 'Contact Number', type: 'text', return_as: 'contact', sample_value: '9829398274', strict_validation: 'mobile', min_length: 10, max_length: 10 },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'MU' },
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'View', shortcut: 'v', color: 'green', icon: 'bx bx-show', function: this.view_modal_open.bind(this), })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_assessments_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.evaluation_management_assessments_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public as: AssessmentService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      exam_code: ['', [Validators.required]],
      exam_id: ['', [Validators.required]],
      academic_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      subject_id: ['', [Validators.required]],
      total_marks: ['1', [Validators.required, Validators.min(1)]],
      passing_marks: ['1', [Validators.required, Validators.min(1)]],
      evaluation_start_date: ['', [Validators.required]],
      evaluation_end_date: ['', [Validators.required]],
      per_day_target_for_faculty: ['', [Validators.required]],
      grace_period: ['', [Validators.required]],
      minimum_time_per_answer_script: ['', [Validators.required]],
      annotations_required: ['', [Validators.required]],
      number_of_evaluations: ['', [Validators.required]],
      header_exminer_required: ['', [Validators.required]],
      persentage_of_script_he_to_check: ['', [Validators.required]],
      qp_pattern: ['', [Validators.required]],
      qp_file: ['',],
      seo_upload: ['',],
      model_answer_sheet: ['',],
    });
  }
  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
    await this.ds?.get_dropdown_list(['university', 'program', 'stream', 'course', 'subject', 'academic-year', 'college', 'exam', 'level']);
  }
  async get_list(filter?: any) {
    try {
      const res = await this.as.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  open_script_page() {
    this.route.navigate(['/script/list']);
  }
  open_add_script_page() {
    this.route.navigate(['/add-script/list']);
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async view_modal_open(item: any, index: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/assessment/form'], {
        queryParams: { id: id, action: 'view' },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  async delete_university() {
    try {
      let res = await this.as.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.as.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  view_scripts(item: any) { }
  async open_form_modal(item?: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/assessment/form'], {
        queryParams: { id: id },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.as.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.as.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      await this.gs.bulk_form_submission(data, this.as, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  showFileLink(params: any, defaultFileName?: string) {
    if (!params.value) return '-';

    let fileType = '';
    let downloadAttr = '';
    let href = params.value;

    if (params.value.startsWith('data:text/csv')) {
      fileType = 'CSV';
      downloadAttr = `download="${defaultFileName || 'file.csv'}"`;
    } else if (params.value.startsWith('data:application/pdf')) {
      fileType = 'PDF';
      downloadAttr = '';

      const byteString = atob(params.value.split(',')[1]);
      const mimeString = params.value.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      href = URL.createObjectURL(blob);
    } else {
      fileType = 'File';
    }

    return `
    <a href="${href}" target="_blank" ${downloadAttr} style="color:#2563eb; text-decoration:underline;">
      View ${fileType}
    </a>
  `;
  }






}
